var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelplineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2022_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.44116C11.415 2.44116 8.49377 5.35866 8.49377 8.94366C8.49377 8.99616 8.50877 9.04491 8.50877 9.09741C9.58502 5.95116 12.0863 3.73866 14.9963 3.73866C17.9063 3.73866 20.4075 5.95116 21.4838 9.09741C21.4838 9.04491 21.4988 8.99616 21.4988 8.94366C21.4988 5.35866 18.5813 2.44116 14.9963 2.44116H15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.03613C11.8275 5.03613 9.24377 8.40363 9.24377 12.5399C9.24377 13.2299 9.32252 13.8974 9.45752 14.5349C10.275 15.1874 12.7163 16.1024 15.0038 16.1024C15.3638 16.1024 15.6525 16.3949 15.6525 16.7511C15.6525 17.1074 15.36 17.4036 15.0038 17.4036C13.6163 17.4036 11.5988 17.0286 10.0538 16.3574C11.0588 18.5586 12.8963 20.0436 15.0038 20.0436C18.1763 20.0436 20.76 16.6761 20.76 12.5399C20.76 8.40363 18.1763 5.03613 15.0038 5.03613H15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19627 10.2451H5.89502V14.1489H7.19627V10.2451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 30C18.2738 30 21.3 28.9425 23.7713 27.1575H6.22876C8.69626 28.9425 11.7263 30 15 30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.105 10.2451H22.8037V14.1489H24.105V10.2451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.73125 0 0 6.7275 0 15C0 18.555 1.245 21.8213 3.31875 24.3938C3.49125 23.0175 4.6875 22.4925 7.51875 21.255C8.2125 20.9513 8.99625 20.61 9.88875 20.2013L9.93 20.1825L9.96375 20.2125C10.2638 20.5013 10.5938 20.7788 10.9462 21.03L11.0363 21.0938L10.935 21.1425C9.81375 21.6637 8.8425 22.0912 8.02125 22.4513C4.9725 23.7825 4.59 24.0413 4.59 24.765C4.59 25.2638 5.08125 25.8638 5.68875 25.8638H24.3187C24.9262 25.8638 25.4175 25.26 25.4175 24.765C25.4175 24.0413 25.0312 23.7787 21.9825 22.4513C21.1612 22.0912 20.19 21.6637 19.0687 21.1425L18.9675 21.0938L19.0575 21.03C19.4137 20.7788 19.7437 20.505 20.0438 20.2125L20.0737 20.1825L20.115 20.2013C21.0075 20.61 21.7913 20.9513 22.485 21.255C25.3162 22.4925 26.5163 23.0175 26.685 24.3938C28.7588 21.8213 30.0037 18.555 30.0037 15C30 6.7275 23.2725 0 15 0ZM25.4062 14.1488C25.4062 14.865 24.825 15.45 24.105 15.45H22.8038C22.38 15.45 22.0163 15.2325 21.78 14.9175C20.9475 18.615 18.225 21.3375 15 21.3375C11.775 21.3375 9.17625 18.7463 8.27625 15.18C8.23125 15.1275 8.19375 15.0675 8.15625 15.0112C7.92 15.2775 7.5825 15.45 7.19625 15.45H5.895C5.17875 15.45 4.59375 14.8687 4.59375 14.1488V10.245C4.59375 9.52875 5.175 8.94375 5.895 8.94375H7.19625C7.19625 4.635 10.6912 1.14 15 1.14C19.3088 1.14 22.8038 4.635 22.8038 8.94375H24.105C24.825 8.94375 25.4062 9.525 25.4062 10.245V14.1488Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2022_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelplineIcon);
export default __webpack_public_path__ + "static/media/helpline-icon.92bb0c92522a32b4f2c4ce9c7a5002e5.svg";
export { ForwardRef as ReactComponent };